import styled from "styled-components";

const S = {
    Wrapper: styled.section`
        width: 100%;
        background: #f8fafc;
        min-height: 100vh;
        padding-bottom: 60px;
    `,
    Top: styled.div`
        grid-area: headerleft;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 40px;
        align-items: left;
        background: linear-gradient(135deg, #00A9C4 0%, #00798c 100%);
        @media (max-width: 648px){
            padding: 20px 16px;
        }
    `,
    Header: styled.h1`
        color: white;
        font-size: 32px;
        margin: 0;
        @media (max-width: 648px){
            font-size: 22px;
        }
    `,
    Span: styled.div`
        color: white;
        font-size: 14px;
        margin: 0;
        a {
            color: white;
            text-decoration: none;
        }
    `,
    Section: styled.section`
        max-width: 1000px;
        margin: 40px auto;
        padding: 40px;
        background: white;
        border-radius: 20px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
        box-sizing: border-box;

        @media (max-width: 768px) {
            margin: 20px 14px;
            padding: 24px 16px;
            border-radius: 16px;
        }

        h1 {
            color: #00A9C4;
            font-size: 2.2em;
            margin-bottom: 20px;

            @media (max-width: 768px) {
                font-size: 1.6em;
            }
        }

        h2 {
            color: #00798c;
            font-size: 1.5em;
            margin-top: 30px;
            margin-bottom: 14px;

            @media (max-width: 768px) {
                font-size: 1.25em;
                margin-top: 20px;
            }
        }

        h3 {
            color: #334155;
            font-size: 1.2em;
            margin-top: 20px;
            margin-bottom: 10px;

            @media (max-width: 768px) {
                font-size: 1.1em;
            }
        }

        p {
            font-size: 1.05em;
            line-height: 1.7;
            color: #475569;
            margin-bottom: 14px;

            @media (max-width: 768px) {
                font-size: 0.95em;
                line-height: 1.6;
            }
        }
    `,
    Sertifika: styled.div`
        grid-area: headerright;
        background: linear-gradient(135deg, #00A9C4 0%, #00798c 100%);
        display: flex;
        flex-direction: row;
        justify-content: right;
        padding: 40px;
        align-items: center;
        @media (max-width: 648px){
            padding: 20px 16px;
        }
        svg, img {
            margin: 5px;
            width: 70px;
            height: 70px;
            @media (max-width: 648px){
                width: 30px;
                height: 30px;
            }
        }
    `
};

export default S;